import { SortableContainer } from 'react-sortable-hoc';

const SortableItemsContainer = SortableContainer(({ children }) => {
  return children;
});

export default SortableItemsContainer;
